import { render } from "./HomeThreePage.vue?vue&type=template&id=586d0885&ts=true"
import script from "./HomeThreePage.vue?vue&type=script&lang=ts"
export * from "./HomeThreePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__